import { createStore } from 'vuex'

export default createStore({
  state: {
    route: ['PRE0'],
    levels: [],
    answers: [],
    advisor: null,
    currentLevel: 'PRE0',
    disabledFullScreens: [],
    advisorIcon: null,
    advisorIcons: [
      { id: 'vroni', icon: '/product-advisor/images/customers/Produktberater_80x80px_Vroni.png', preview: '/product-advisor/images/customers/Produktberater_327x144px_Vroni.png', iconBig: '/product-advisor/images/customers/Produktberater_235x186px_Vroni.png' },
      { id: 'johannes', icon: '/product-advisor/images/customers/Produktberater_80x80px_Johannes.png', preview: '/product-advisor/images/customers/Produktberater_327x144px_Johannes.png', iconBig: '/product-advisor/images/customers/Produktberater_235x186px_Johannes.png' },
      { id: 'caro', icon: '/product-advisor/images/customers/Produktberater_80x80px_Caro.png', preview: '/product-advisor/images/customers/Produktberater_327x144px_Caro.png', iconBig: '/product-advisor/images/customers/Produktberater_235x186px_Caro.png' },
    ]
  },
  mutations: {
    setAdvisorIcon(state, advisorIcon) {
      state.advisorIcon = advisorIcon
    },
    setAdvisor(state, advisor) {
      state.advisor = advisor
    },
    addValue(state, value) {
      state.answers.push(value)
    },
    setDisabledFullScreens(state, disabledFullScreens) {
      state.disabledFullScreens = disabledFullScreens
    },
    setLevels(state, levels) {
      state.levels = levels
    },
    setCurrentLevel(state, currentLevel) {
      if (!currentLevel.startsWith('F')) {
        state.route.push(currentLevel)
      }
      state.currentLevel = currentLevel
    },
    decrementLevel(state) {
      let lastRouteElement = state.route.pop()
      if (lastRouteElement) {
        state.currentLevel = state.route[state.route.length - 1]
      }
      state.answers.pop()
    },
  },
  actions: {
  },
  getters: {
    route: (state) => state.route,
    answers: (state) => state.answers,
    advisor: (state) => state.advisor,
    currentLevel: (state) => state.currentLevel,
    disabledFullScreens: (state) => state.disabledFullScreens,
    advisorIcon: (state) => state.advisorIcon,
    advisorIcons: (state) => state.advisorIcons,
    levelComponent: (state) => state.levels.find(item => item.id == state.currentLevel)
  }
})
